import { render, staticRenderFns } from "./IMFooter.vue?vue&type=template&id=15d43fe7&"
import script from "./IMFooter.vue?vue&type=script&lang=js&"
export * from "./IMFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports